const strings = {
  selector: {
    origin: '[data-search-overlay-modal]',
    opens: '[data-search-overlay-open]',
    closes: '[data-search-overlay-close]',
  },
  dataset: {
    state: 'searchOverlayModal',
  },
  state: {
    active: 'active',
    inactive: 'inactive',
  },
};
const fixedFooterModal = document.querySelector(strings.selector.origin);
document
  .querySelectorAll(strings.selector.opens)
  .forEach((el) =>
    el.addEventListener(
      'click',
      (evt) => (fixedFooterModal.dataset[strings.dataset.state] = strings.state.active),
    ),
  );
document
  .querySelectorAll(strings.selector.closes)
  .forEach((el) =>
    el.addEventListener(
      'click',
      (evt) => (fixedFooterModal.dataset[strings.dataset.state] = strings.state.inactive),
    ),
  );
